module.exports = __webpack_public_path__ + "img/imaizumi@1x.17567973.png";